import { useAuth } from '../context/auth-context';
import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {

    const { isAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuth) {
            navigate('/customer/dashboard', {replace: true});
        }
        navigate('/login');
    }, [isAuth]);

    return (
        <Container>
            Page Not Found!
        </Container>
    )
}

export default PageNotFound;
